import { useState } from 'react';
import { Popover, PopoverContent, OverlayTrigger } from 'react-bootstrap';
import copyIcon from '../../images/clipart.png';
import searchIcon from '../../images/Search.svg';
import infoIcon from '../../images/info-blue.svg';

const icons = {
  magnifyingGlass: searchIcon,
  info: infoIcon,
};

const CopyPastePopUp = ({ jobRef, icon = 'magnifyingGlass' }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(jobRef);
      setIsCopied(true);
    } catch {
      setIsCopied(false);
      console('Failed to copy!');
    }

    setTimeout(() => {
      setIsCopied(false);
    }, 100);
  };

  return (
    <OverlayTrigger
      placement="right"
      trigger={['click']}
      rootClose
      overlay={
        <Popover style={{ padding: '6px', width: '500px' }}>
          <PopoverContent>
            <div className="d-flex ">
              <p className={isCopied ? 'copied-text' : ''}>{jobRef}</p>
              <div style={{ marginLeft: '13px' }}>
                <img
                  src={copyIcon}
                  alt={'Full Reference'}
                  style={{
                    cursor: 'pointer',
                    width: '19px',
                    height: '19px',
                    marginBottom: '15px',
                  }}
                  onClick={(e) => copyToClipboard()}
                />
              </div>
            </div>
          </PopoverContent>
        </Popover>
      }
    >
      <img
        src={icons[icon]}
        alt={'Copy to clipboard'}
        style={{
          cursor: 'pointer',
          width: '14px',
          height: '14px',
        }}
      />
    </OverlayTrigger>
  );
};

export default CopyPastePopUp;
